export default  {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyDetailsController',
    template: require('../views/property.style.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.style.component.js